export enum ServiceType {
  SERVICE = "SERVICE",
  REPAIR = "REPAIR",
}
